var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2301 25.7399C30.3014 24.9611 24.8551 21.5122 23.9498 21.6705C23.5248 21.746 23.1997 22.1083 22.3295 23.1464C21.9271 23.6573 21.4851 24.1358 21.0077 24.5775C20.1331 24.3663 19.2864 24.0524 18.4854 23.6425C15.3439 22.1131 12.8059 19.5744 11.2774 16.4324C10.8675 15.6314 10.5537 14.7847 10.3424 13.91C10.7841 13.4327 11.2626 12.9907 11.7736 12.5883C12.8106 11.7181 13.1739 11.3951 13.2494 10.968C13.4077 10.0606 9.95563 4.61636 9.18 3.68773C8.85488 3.30311 8.5595 3.04492 8.18125 3.04492C7.08475 3.04492 2.125 9.17767 2.125 9.97242C2.125 10.0372 2.23125 16.4218 10.2946 24.6254C18.4981 32.6887 24.8827 32.7949 24.9475 32.7949C25.7423 32.7949 31.875 27.8352 31.875 26.7387C31.875 26.3604 31.6168 26.065 31.2301 25.7399Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4375 16.8574H26.5625C26.56 14.6039 25.6636 12.4433 24.0701 10.8498C22.4766 9.2563 20.3161 8.35995 18.0625 8.35742V10.4824C19.7527 10.4841 21.3733 11.1563 22.5684 12.3515C23.7636 13.5467 24.4358 15.1672 24.4375 16.8574Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 16.8574H31.875C31.8708 13.1954 30.4142 9.6846 27.8248 7.09517C25.2353 4.50574 21.7245 3.04914 18.0625 3.04492V5.16992C21.1611 5.17358 24.1317 6.40611 26.3228 8.59715C28.5138 10.7882 29.7463 13.7588 29.75 16.8574Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.7766d75c9f66452660da761e6c5aa920.svg";
export { ForwardRef as ReactComponent };